import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Reveal from "@/components/Reveal";

// Visible FAQ accordion plus schema.org FAQPage JSON-LD so AI agents and
// search engines can read the same questions and answers programmatically.
const FAQSection = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <section className="faq-section" data-testid="faq-section" aria-label="Frequently asked questions">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="faq-inner">
        <Reveal y={20}>
          <h2 className="section-title faq-title">
            Frequently Asked <span className="text-green">Questions.</span>
          </h2>
        </Reveal>
        <div className="faq-list">
          {items.map((item, index) => {
            const open = openIndex === index;
            return (
              <Reveal key={index} delay={index * 0.06} y={12} className={open ? "faq-item faq-item-open" : "faq-item"}>
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={open}
                  data-testid={`faq-question-${index}`}
                  onClick={() => setOpenIndex(open ? -1 : index)}
                >
                  <span>{item.q}</span>
                  <ChevronDown className="faq-chevron" strokeWidth={1.8} />
                </button>
                <div className="faq-answer" data-testid={`faq-answer-${index}`}>
                  <p>{item.a}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
